import styled from "styled-components";

import { ColoredText, T_PLAIN_big } from "../../global.style";


export const GrantSplitDialogHeader = styled.div `
    display: flex;
    ${T_PLAIN_big};
    margin-bottom: 10px;
`;

export const GrantSplitDialogHeaderValue = styled(ColoredText) `
    margin-left: 7px;
`;

export const GrantDocHeader = styled.div `
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: bold;
`;

export const GrantDocDraftHeader = styled.div `
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: bold;
`;

export const ClaimRow = styled.div `
    display: flex;
    align-items: center;
`;

export const LinkWrapper  = styled.div `
    margin-left: 5px;
`;

export const AllTabsTableHeader = styled.div `
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: bold;
`;

export const AllTabsWrapper = styled.div `
    padding-top: 40px;
`;

export const AllTabsMain = styled.div `
    padding-top: 10px; 
`;

export const GrantActionButton = styled.div `
    margin-top: 10px;
    font-size: 12px;
`;